/**
 * src/auth/msalConfig.ts
 *
 * Microsoft Authentication Library (MSAL) configuration.
 * Values are read from environment variables set in .env.local.
 *
 * Required app registration permissions (delegated):
 *   - Files.ReadWrite.All    → upload / lister fichiers sur les sites SharePoint d'organisation
 *   - Sites.Read.All         → lire les drives et dossiers SharePoint
 *   - User.Read              → profil de l'utilisateur connecté (optionnel)
 *
 * Note : Files.ReadWrite (sans .All) ne donne accès qu'au OneDrive personnel — pas aux sites SP.
 * Ces permissions nécessitent un consentement administrateur sur le tenant Azure AD.
 */

import { Configuration, PopupRequest } from "@azure/msal-browser";

// ── MSAL instance config ──────────────────────────────────────────────────────

export const msalConfig: Configuration = {
  auth: {
    clientId:    import.meta.env.VITE_MSAL_CLIENT_ID as string,
    authority:   `https://login.microsoftonline.com/${import.meta.env.VITE_MSAL_TENANT_ID as string}`,
    redirectUri: import.meta.env.VITE_MSAL_REDIRECT_URI as string ?? window.location.origin,
  },
  cache: {
    cacheLocation:      "sessionStorage", // use "localStorage" to persist across tabs
    storeAuthStateInCookie: false,
  },
};

// ── Token request scopes ──────────────────────────────────────────────────────

/** Scopes requested when uploading to SharePoint via Microsoft Graph */
export const graphScopes: PopupRequest = {
  scopes: [
    "Files.ReadWrite.All", // upload / lister fichiers sur les sites SharePoint d'organisation
    "Sites.Read.All",      // lire les drives et dossiers SharePoint
    "User.Read",           // profil de l'utilisateur connecté
  ],
};

// ── SharePoint config (read from env) ────────────────────────────────────────

export const sharePointConfig = {
  siteId:     import.meta.env.VITE_SP_SITE_ID     as string,
  driveId:    import.meta.env.VITE_SP_DRIVE_ID    as string,
  folderPath: import.meta.env.VITE_SP_FOLDER_PATH as string ?? "Rapports/2024",
} as const;
